import React from "react"
import { css, Theme } from "@emotion/react"
import { Heading, Icon, Paragraph } from "@ncs/web-legos"

export const LoginSignupIntro: React.FC = () => {
	return (
		<div css={introDiv}>
			<Paragraph mb={1.5} customColor="#003264" css={introTitleStyle}>
				NCS eStore
			</Paragraph>
			<Heading variant="h1" bold mb={2} css={introSubtitleStyle}>
				Making Life Better Through Carwashing
			</Heading>
			<Paragraph mb={1.5} customColor="#4B5563" css={introDescriptionStyle}>
				Our eStore connects your business to your partnership with NCS, from purchasing
				parts to managing equipment service.
			</Paragraph>
			<ul css={perksListStyle}>
				<li>
					<Icon icon="shopping-cart" family="solid" color="white" css={iconContainer} />
					<span css={introBulletStyle}>Shop Parts, Chemicals, & Detail</span>
				</li>
				<li>
					<Icon icon="truck" family="solid" color="white" css={iconContainer} />
					<span css={introBulletStyle}>Check Order Status</span>
				</li>
				<li>
					<Icon icon="dollar" family="solid" color="white" css={iconContainer} />
					<span css={introBulletStyle}>Review & Pay Invoices</span>
				</li>
				<li>
					<Icon
						icon="screwdriver-wrench"
						family="solid"
						color="white"
						css={iconContainer}
					/>
					<span css={introBulletStyle}>Submit Service Requests</span>
				</li>
				<li>
					<Icon icon="message" family="solid" color="white" css={iconContainer} />
					<span css={introBulletStyle}>Access & Monitor Connected Ryko Equipment</span>
				</li>
			</ul>
		</div>
	)
}

const perksListStyle = (theme: Theme) => css`
	margin: 2.5rem 0.5rem;

	${theme.breakpoints.down("sm")} {
		margin: 0;
	}
	li {
		display: flex;
		align-items: flex-start;
		column-gap: 1.1rem;
		margin-bottom: 2.25rem;
		align-items: center;
		> svg {
			position: relative;
			top: 3px;
			opacity: 0.75;
		}
		> span {
			font-size: 1.25rem;
		}
	}
`

const introDiv = css`
	background-color: #eaf5ff;
	border-radius: 1em;
	padding: 32px;
`

const iconContainer = (theme: Theme) => css`
	border-radius: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: #003264;
	width: 1.5rem;
	height: 1.5rem;
	padding: 1rem;

	@media (max-width: ${theme.breakpoints.values.sm}px) {
		width: 19.2px;
		height: 19.2px;
		padding: 12px;
	}
)
`

const introBulletStyle = css`
	color: #111827;
	font-size: 16px;
	font-style: normal;
	font-weight: 500;
	line-height: 28px;
	letter-spacing: -0.32px;
`

const introDescriptionStyle = css`
	color: #4b5563;
	font-size: 16px;
	font-style: normal;
	font-weight: 500;
	line-height: 24px;
	letter-spacing: -0.32px;
`

const introSubtitleStyle = (theme: Theme) => css`
	color: #111827;

	h1 {
		font-size: 28px;
		line-height: 36px;
		font-style: normal;
		font-weight: 700;
		letter-spacing: -0.56px;
	}
`

const introTitleStyle = css`
	color: #003264;
	font-size: 18px;
	font-style: normal;
	font-weight: 700;
	line-height: 24px; /* 133.333% */
	letter-spacing: 1px;
`
